export interface MailHtml {
    noOrder?: string;
    tema?: string;
    title: string;
    description?: any;
    comments?: string;
    namelink: string;
    link: string;
    tblhead: any[];
    tbldetail: any[];
}
